import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import ProductObservations from '../ProductObservations/ProductObservations';

const TaskModal = ({ show, onHide, product, isEcommerce }) => {
    if (!product) return null;

    const productCode = isEcommerce ? product.codigo : product.codigoInterno;
    const productName = isEcommerce ? product.nome : product.descricao;

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Ações do Produto: <span className="text-primary">{productCode}</span>
                    <br />
                    <small className="text-muted" style={{ fontSize: '0.7em' }}>{productName}</small>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ProductObservations
                    productCode={productCode}
                    origem={isEcommerce ? 'ecommerce' : 'loja_fisica'}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TaskModal;
